import { useClient } from '@sunucupark/client-react';
import type { WebClient } from './client';

/**
 * The injected client with the browser's own additions (the cookie sign-in).
 * The composition root builds exactly one, so the cast is safe here and
 * nowhere else — `createWebClient` is what `Providers` is given.
 */
export function useWebClient(): WebClient {
  return useClient() as WebClient;
}
